import SpecialNumbers from 'pages/ga/specialNumbers/Index';
import SpecialNumbersForm from 'pages/ga/specialNumbers/Form';

const SpecialNumbersRoutes = [
    { index: true, element: <SpecialNumbers /> },
    { path: 'add', element: <SpecialNumbersForm mode="add" /> },
    {
        path: 'edit/:id',
        element: <SpecialNumbersForm mode="edit" />,
    },
];

export default SpecialNumbersRoutes;
